import React from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'next-i18next';

import { NS } from '@/constants';
import { connect } from 'react-redux';
import { API_URL, getApiUrl } from '@/utils/api';

export class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null, errorInfo: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error(error, errorInfo);

    const { cart, user } = this.props;

    const logUrl = getApiUrl(API_URL.ADMIN, '/logEvent');

    // Extraire explicitement les propriétés d'erreur importantes
    const errorDetails = {
      message: error.message,
      name: error.name,
      stack: error.stack
    };

    // Convertir l'objet errorInfo en objet sérialisable
    const errorInfoDetails = {
      componentStack: errorInfo.componentStack
    };

    const cookies = document?.cookie;
    this.setState({ errorInfo });

    fetch(logUrl, {
      method: 'POST',
      headers: {
        'content-Type': 'application/json'
      },
      body: JSON.stringify({
        cartId: cart?.content?.id,
        message: `Error Boundary: ${error.message || 'Something went wrong'}. Cookies: ${cookies}`,
        storeId: user?.content?.storeId,
        url: typeof window !== 'undefined' ? window.location.href : null,
        userId: user?.content?._id,
        data: JSON.stringify({
          error: errorDetails,
          errorInfo: errorInfoDetails
        })
      })
    }).catch((error) => {
      console.error('sendAjaxErrorLog error:', error);
    });
  }

  render() {
    return this.state.hasError ? (
      <h1 className="text-center mt-5">{this.props.t?.('alert.error') || 'Something went wrong.'}</h1>
    ) : (
      this.props.children
    );
  }
}

ErrorBoundary.propTypes = {
  t: PropTypes.func,
  children: PropTypes.node
};

const mapStateToProps = (state) => ({
  user: state.user,
  cart: state.cart
});

export default connect(mapStateToProps)(
  withTranslation(NS.COMMON)(ErrorBoundary)
);
